<template>
<div class="bash-wrap jxc-header-wrap" :style="'background:url(' + indata.bgcImage + ') no-repeat 50% 50%;'">
            <div class="bash-box jxc-header-box">
                <p class="h1">{{ indata.FirstTitle }}</p>
                <p class="h2">{{ indata.subTitle }}</p>
                <ul>
                    <li><a class="go-next" :href="indata.btnUrl1" target="_blank">{{indata.btnUrl1Name}}</a></li>
                    <li><a :href="indata.btnUrl2" target="_blank">{{indata.btnUrl2Name}}</a></li>
                </ul>
                <div class="code-img-box"><img :src="indata.showImage" class="code-img"> </div>
            </div>
           
        </div>
</template>

<style scoped src="../../public/css/drp.css">
</style>
<script>
export default {
  name: "Templates5",
  props: {
    indata: Array,
  },
  data() {
    return {
      NowIndex: 0,
   
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>
